<template>
  <nav class="navbar" :class="{
    navColorExpanded: sideBarExpanded,
    navColorCompressed: !sideBarExpanded,
  }">
    <!-- Expansion/Contraction Control - &#9776 is a set of horizontal lines -->

    <div class="outer">
      <div class="floatcontainer">
        <div id="navCtrl" @click="ToggleSidebar" :class="{
          innerExpanded: sideBarExpanded,
          innerCompressed: !sideBarExpanded,
        }">
          &#9776;
        </div>
      </div>
    </div>

    <div class="allLinksDiv">
        <!-- -------------------- Group Home ---------------------------- -->
        <!--  Revised by Reno on 2/17/23.  About and FAQ links will be moved to
              the Quick Links section (to be built); Home Page link elevated to
              top level of the navigation menu; original items commented below -->
        <!-- +++++++++++++++++++++++ -->

        <div>
            <div>

                <router-link class="groupFont groupFolder otherLink" v-if="sideBarExpanded"
                             :to="{ name: 'home' }">Home</router-link>

            </div>
            <!-- <div class="groupFont groupFolder" v-if="sideBarExpanded" @click="toggleHomeGroup">> Home</div> -->
        </div>

        <!-- -------------------- Group Contractor Mgmt START ---------------------------- -->
        <!-- +++++++++++++++++++++++ -->
        <!-- <div>
      <div class="groupFont groupFolder" @click="toggleContractorGroup" v-if="sideBarExpanded">> Contractor Mgmt</div>
    </div> -->
        <!-- ------------ arrow down ------------ -->
        <div v-if="useArrowIcon">
            <div class="groupFont groupFolder" @click="toggleContractorGroup" v-if="sideBarExpanded && !showContractorGroup">
                <span style="color: darkred; font-size: 18px; font-weight: normal;">></span> Contractor Management
            </div>
            <div class="groupFont groupFolder" @click="toggleContractorGroup" v-if="sideBarExpanded && showContractorGroup">
                <span style="font-size: 18px; color: darkred; font-weight: normal;">&#8595;</span> Contractor Management
            </div>
        </div>

        <!-- ------------ plus minus ------------ -->
        <div v-if="usePlusIcon">
            <div class="groupFont groupFolder" @click="toggleContractorGroup" v-if="sideBarExpanded && !showContractorGroup">
                <span style="color: darkred; font-size: 18px; font-weight: normal;">+</span> Contractor Management
            </div>
            <div class="groupFont groupFolder" @click="toggleContractorGroup" v-if="sideBarExpanded && showContractorGroup">
                <span style="font-size: 24px; color: darkred; font-weight: normal;">-</span> Contractor Management
            </div>
        </div>

        <!-- ------------ caret icons ------------ -->
        <div v-if="useCarotIcon">
            <div class="groupFont groupFolder" @click="toggleContractorGroup" v-if="sideBarExpanded && !showContractorGroup">
                <span style="color: darkred; font-size: 18px; font-weight: normal;">></span> Contractor Management
            </div>
            <div class="groupFont groupFolder" @click="toggleContractorGroup" v-if="sideBarExpanded && showContractorGroup">
                <span style="font-size: 16px; color: darkred; font-weight: normal;">&or;</span> Contractor Management
            </div>
        </div>

        <!-- +++++++++++++++++++++++ -->
        <!--  ITEMS COMMENTED OUT FOR INITIAL DEPLOYMENT.  We will work these into the applcation
    post-deployment-->

        <router-link v-if="showContractorGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'accountManagement' }">Account Management</router-link>

        <router-link v-if="showContractorGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'addPersonAdmin' }">Add Person</router-link>

        <!-- Admin-level link moved from the Processing menu -->
        <!-- <router-link v-if="showContractorGroup && sideBarExpanded && showAdmin"
      class="dropdown-item otherLinks itemGroupIndent" :to="{ name: 'contractDashboard' }">Contract
      Dashboard</router-link> -->

        <router-link v-if="showContractorGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'processMasterList' }">
            Process Master
            List
        </router-link>

        <router-link v-if="showContractorGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'revocationWatchList' }">Revocation/Watchlist</router-link>
        <!--
    <router-link v-if="showContractorGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'revocationSearch' }">Revocation Search</router-link>

    <router-link v-if="showContractorGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'deashBoard' }">Dashboard</router-link> -->
        <!-- -------------------- Group Contractor Mgmt END ---------------------------- -->
        <!-- -------------------- Group Reports START ---------------------------- -->
        <!-- +++++++++++++++++++++++ -->
        <!-- ------------ arrow down ------------ -->
        <div v-if="useArrowIcon">
            <div class="groupFont groupFolder" @click="toggleReportGroup" v-if="sideBarExpanded && !showReportGroup">
                <span style="color: darkred; font-size: 18px; font-weight: normal;">></span> Reports
            </div>
            <div class="groupFont groupFolder" @click="toggleReportGroup" v-if="sideBarExpanded && showReportGroup">
                <span style="color: darkred; font-size: 18px; font-weight: normal;">&#8595;</span> Reports
            </div>
        </div>

        <!-- ------------ plus minus ------------ -->
        <div v-if="usePlusIcon">
            <div class="groupFont groupFolder" @click="toggleReportGroup" v-if="sideBarExpanded && !showReportGroup">
                <span style="color: darkred; font-size: 18px; font-weight: normal;">+</span> Reports
            </div>
            <div class="groupFont groupFolder" @click="toggleReportGroup" v-if="sideBarExpanded && showReportGroup">
                <span style="color: darkred; font-size: 24px; font-weight: normal;">-</span> Reports
            </div>
        </div>

        <!-- ------------ caret icons ------------ -->
        <div v-if="useCarotIcon">
            <div class="groupFont groupFolder" @click="toggleReportGroup" v-if="sideBarExpanded && !showReportGroup">
                <span style="color: darkred; font-size: 18px; font-weight: normal;">></span> Reports
            </div>
            <div class="groupFont groupFolder" @click="toggleReportGroup" v-if="sideBarExpanded && showReportGroup">
                <span style="color: darkred; font-size: 16px; font-weight: normal;">&or;</span> Reports
            </div>
        </div>

        <!-- +++++++++++++++++++++++ -->
        <!--
    <router-link v-if="showReportGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'armingRosterExp' }">Arming Roster w/Exp</router-link>

    <router-link v-if="showReportGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'armingCompliance' }">Arming Compliance</router-link> -->

        <router-link v-if="showReportGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'armedByLocation' }">Armed By Locaton</router-link>

        <router-link v-if="showReportGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'consusReport' }">Census</router-link>

        <router-link v-if="showReportGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'armingRosterExp' }">Arming Roster Expired</router-link>
        <router-link v-if="showReportGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'lookForwardContract' }">Looking Forward - Contract Exp</router-link>
        <!--
    <router-link v-if="showReportGroup && sideBarExpanded" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'docExpiration' }">Document Expiration</router-link>

    <router-link v-if="showReportGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'confirmDate' }">Confirm Date</router-link>

    <router-link v-if="showReportGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'vendorKcorPoc' }">KO/COR/Vendor POC</router-link>

          <router-link v-if="showReportGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
            :to="{ name: 'lookForwardTotals' }">Looking Forward - Monthly Totals</router-link>

          <router-link v-if="showReportGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
            :to="{ name: 'nonStandardWeaponPerson' }">Non-Standard Weapon-Person</router-link>

          <router-link v-if="showReportGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
            :to="{ name: 'nonUsStatus' }">Non-US Status</router-link>

          <router-link v-if="showReportGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
            :to="{ name: 'revocationWatchList' }">Revocation/Watch List</router-link>

          <router-link v-if="showReportGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
            :to="{ name: 'statusRenewal' }">Status w/Renewal</router-link>

          <router-link v-if="showReportGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
            :to="{ name: 'totalsBySecurityType' }">Totals by Security Type</router-link> -->
        <!-- -------------------- Group Reports END ---------------------------- -->
        <!-- -------------------- Group Administration START ---------------------------- -->
        <!-- +++++++++++++++++++++++ -->
        <!-- <div>
      <div class="groupFont groupFolder" @click="toggleDevAdminGroup" v-if="sideBarExpanded && showAdmin">>
        Administration</div>
    </div> -->

        <div v-if="showAdmin">
            <!-- ------------ arrow down ------------ -->
            <div v-if="useArrowIcon">
                <div class="groupFont groupFolder" @click="toggleDevAdminGroup" v-if="sideBarExpanded && !showAdminGroup">
                    <span style="color: darkred; font-size: 18px; font-weight: normal;">></span> Administration
                </div>
                <div class="groupFont groupFolder" @click="toggleDevAdminGroup" v-if="sideBarExpanded && showAdminGroup">
                    <span style="color: darkred; font-size: 16px; font-weight: normal;">&#8595;</span> Administration
                </div>
            </div>

            <!-- ------------ plus minus ------------ -->
            <div v-if="usePlusIcon">
                <div class="groupFont groupFolder" @click="toggleDevAdminGroup" v-if="sideBarExpanded && !showAdminGroup">
                    <span style="color: darkred; font-size: 18px; font-weight: normal;">+</span> Administration
                </div>
                <div class="groupFont groupFolder" @click="toggleDevAdminGroup" v-if="sideBarExpanded && showAdminGroup">
                    <span style="color: darkred; font-size: 24px; font-weight: normal;">-</span> Administration
                </div>
            </div>

            <!-- ------------ caret icons ------------ -->
            <div v-if="useCarotIcon">
                <div class="groupFont groupFolder" @click="toggleDevAdminGroup" v-if="sideBarExpanded && !showAdminGroup">
                    <span style="color: darkred; font-size: 18px; font-weight: normal;">></span> Administration
                </div>
                <div class="groupFont groupFolder" @click="toggleDevAdminGroup" v-if="sideBarExpanded && showAdminGroup">
                    <span style="color: darkred; font-size: 16px; font-weight: normal;">&or;</span> Administration
                </div>
            </div>
        </div>
        <!-- +++++++++++++++++++++++ -->
        <!--<router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                          :to="{ name: 'addPersonAdmin' }">Add Person</router-link>--> 
        <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'agencyRecords' }">Agency Records</router-link>
        <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'armingAuthorityRecords' }">Arming Authority Records</router-link>
        <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'campLocationMgmt' }">Camp Location Management</router-link>
        <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'companyRecords' }">Company Records</router-link>
        <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'contractRecords' }">Contract Records</router-link>
        <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'contractUserMgmt' }">Contract User Management</router-link>
        <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'duplicateRecordMgmt' }">Duplicate Record Management</router-link>
        <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'searchAdmin' }">Search</router-link>
        <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'statusTracker' }">Status Tracker</router-link>
        <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
                     :to="{ name: 'userRecords' }">User Records</router-link>


        <!-- <hr style="background-color: red;">

    <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
    :to="{ name: 'appColors' }">Application Colors</router-link>

    <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
    :to="{ name: 'documentDownload' }">Document Download</router-link> -->
        <!--
    <hr v-if="showAdminGroup && sideBarExpanded && showAdmin" class=" bg-primary hrSizes" />

    <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'appColors' }">Application Colors</router-link>

    <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'hostCmpGrid' }">CmpGrid Component</router-link>

    <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'hostCmpGridComplete' }">CmpGrid Component Complete</router-link>

    <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'hostCmpGridActions' }">CmpGrid Component Actions</router-link>

    <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'docCompHosting' }">DocComp Component Host</router-link>

    <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'hostFileDownloadTesting' }">File Download Testing</router-link>

    <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'pageTemplate' }">Page Template</router-link>

    <router-link v-if="showAdminGroup && sideBarExpanded && showAdmin" class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'hostUploadAgent' }">Host Upload Agent</router-link>
      <router-link  class="dropdown-item otherLinks itemGroupIndent"
      :to="{ name: 'hostUploadAgent' }">Host Upload Agent</router-link>-->
        <!-- -------------------- Group Processing END ---------------------------- -->

    </div>
  </nav>
</template>

<script>

import { store } from "@/store/store.js";

export default {

  data() {
    return {
      sideBarExpanded: true,
      usePlusIcon: true,
      useArrowIcon: false,
      useCarotIcon: false,

      showHomeGroup: false,
      showContractorGroup: false,
      showReportGroup: false,
      showProcessingGroup: false,
      showAdminGroup: false,

      showAdmin: false,
      showVendor: false,
      showKocor: false,
      store,
      roleName: "",
    };
  },

  props: {
    MenuIcon: { type: String, require: false },
  },

  computed: {
    debugging() {
      if (this.store.globalDebugging != null) {
        return this.store.globalDebugging;
      }
      else {
        return false;
      }
    }
  },
  created() {
    //We need a role to initialize this component.
    this.SetRole();
    this.MenuIconFnc();
  },
  watch: {
    'store.authenticatedUser'() {
      this.SetRole();
    },

    MenuIcon: {
      handler: function () {
        this.MenuIconFnc();
      },
      flush: "post",
    },

  },

  emits: ["ToggleSidebar"],

  methods: {

    MenuIconFnc() {
      // console.log('AppSidebar.MenuIconFnc(): this.$data.menuIcon = ', this.$data.menuIcon);

      if (this.MenuIcon) {
        if (this.MenuIcon == 'arrow') {
          this.$data.usePlusIcon = false;
          this.$data.useArrowIcon = true;
          this.$data.useCarotIcon = false;
        } else if (this.MenuIcon == 'caret') {
          this.$data.usePlusIcon = false;
          this.$data.useArrowIcon = false;
          this.$data.useCarotIcon = true;
        } else {
          this.$data.usePlusIcon = true;
          this.$data.useArrowIcon = false;
          this.$data.useCarotIcon = false;
        }

        // console.log('Sidebar: MenuIconFnc(): usePlusIcon = ', this.$data.usePlusIcon);
        // console.log('Sidebar: MenuIconFnc(): useArrowIcon = ', this.$data.useArrowIcon);
        // console.log('Sidebar: MenuIconFnc(): useCarotIcon = ', this.$data.useCarotIcon);
      }
    },

    HandleUserRole() {
      var i_userRole = this.roleName;
      if (i_userRole != "") {

        //console.log('AppSidebar.vue: HandleUserRole: i_userRole = ', i_userRole);
        if (i_userRole == "Vendor") {
          this.$data.showVendor = true;
          this.$data.showKocor = false;
          this.$data.showAdmin = false;
        } else if (i_userRole == "Contract Officer") {
          this.$data.showVendor = false;
          this.$data.showKocor = true;
          this.$data.showAdmin = false;
        } else if (i_userRole == "Admin") {
          this.$data.showVendor = false;
          this.$data.showKocor = false;
          this.$data.showAdmin = true;
        }

      }
    },
    ToggleSidebar() {
      this.$data.sideBarExpanded = !this.$data.sideBarExpanded;
      this.$emit("ToggleSidebar");
    },
    toggleHomeGroup() {
      this.$data.showHomeGroup = !this.$data.showHomeGroup;
    },

    toggleContractorGroup() {
      this.$data.showContractorGroup = !this.$data.showContractorGroup;
    },

    toggleReportGroup() {
      this.$data.showReportGroup = !this.$data.showReportGroup;
    },

    toggleProcessingGroup() {
      this.$data.showProcessingGroup = !this.$data.showProcessingGroup;
    },

    toggleDevAdminGroup() {
      this.$data.showAdminGroup = !this.$data.showAdminGroup;
    },
    SetRole() {
      //console.log("setting role name in app sidebar");
      if (this.store.authenticatedUser != null && this.store.authenticatedUser.roleName != undefined) {
        this.roleName = this.store.authenticatedUser.roleName;
      }
      else if (!this.store.loggedIn && this.store.globalDebugging && this.store.spoofRoleDebugging != null) {
        this.roleName = this.store.spoofRoleDebugging;
      }

      this.HandleUserRole();
    }
  },
};
</script>

<style scoped>
/* ++++++++ grouping ++++++++++++++++++++ */

.expandContractSize {
  font-size: 40;
}

button:hover {
  color: #DC143C;
  font-weight: bold;
}

.itemGroupIndent {
  padding-left: 15px;
  padding-right: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.hrSizes {
  margin-left: 35px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100px;
}

.groupFont {
  color: black;
  font-size: 16px;
}

.groupFolder {
  margin-left: 0px;
  padding: 0px;
  display: inline;
  text-align: left;
  cursor: pointer;
  font-size: 16px;
}

.groupFolder:hover {
  color: blue;
  font-weight: bold;
}

/* +++++++ colors +++++++++++++++++++++ */

#sidebarCtrlID:hover {
  background-color: #000099;
  color: white;
}

.navColorExpanded {
  background-color: #ecf4f9;
  margin-bottom: 40px;
}

.navColorCompressed {
  background-color: white;
  margin-left: 15px;
}


.allLinksDiv {
  text-align: left;
  margin-left: 0px;
}

.otherLinks {
  color: black;
  text-align: left;
  font-size: 14px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.otherLinks:hover {
  color: blue;
  font-weight: bold;
}

/* ++++++++++++++++++++++++++++ */

.outer {
  width: 100%;
}

.floatcontainer {
  float: right;
  width: 30px;
}

.innerExpanded {
  background-color: #ecf4f9;
  cursor: pointer;
}

.innerCompressed {
  background-color: white;
  cursor: pointer;
}

#navCtrl:hover {
  background-color: #000099;
  color: white;
}

/* ##################################### */

a:hover {
  background-color: #ecf4f9;
}

nav a {
  font-weight: normal;
  color: #2c3e50;
}

    nav a.router-link-exact-active {
        color: #1F6748;
        /*color: #29875F*/
        /*color: #42b983;*/
        background-color: #ecf4f9;
    }
</style>
